import React from "react";
import { Link } from "gatsby";

import * as S from "app/components/Button.style";

export const blur = (e) => {
  e.preventDefault();
  e.target.blur();
};

const Btn = ({
  Component = Link,
  onMouseDown,
  label,
  Icon,
  children,
  invert,
  outlined,
  variant = "text",
  ...props
}) => {
  return (
    <Component
      onMouseDown={(e) => {
        blur(e);
        onMouseDown && onMouseDown(e);
      }}
      css={S.btnStyles({ invert, outlined })}
      activeClassName="active"
      variant={variant}
      {...props}
    >
      {children}
      {!children && (
        <>
          <span css={S.textStyles}>{label}</span>
          {Icon &&
            React.cloneElement(Icon, {
              css: S.icon,
            })}
        </>
      )}
    </Component>
  );
};

const WrappedButton = ({ center, ...props }) =>
  center ? (
    <S.CenterWrap>
      <Btn {...props} />
    </S.CenterWrap>
  ) : (
    <Btn {...props} />
  );

export default WrappedButton;
